import { IraUserAssets } from 'screens';

const ReroutingToIraUserAssets = (): JSX.Element => <IraUserAssets />;

export default ReroutingToIraUserAssets;
